import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

import "./CSS/BestSller.css";
import { API_BASE, FILE_BASE } from "../config";

const Bestseller = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =========================================================
  // SAFE VALUE
  // =========================================================
  const getSafeValue = (value, fallback = "") => {
    if (
      value === null ||
      value === undefined
    ) {
      return fallback;
    }

    if (
      typeof value === "string" ||
      typeof value === "number"
    ) {
      return value;
    }

    if (typeof value === "object") {
      return (
        value.name ||
        value.title ||
        value.productName ||
        value.value ||
        value.text ||
        fallback
      );
    }

    return fallback;
  };

  // =========================================================
  // GET PRODUCT ID
  // =========================================================
  const getProductId = (item) => {
    return (
      item?.id ||
      item?.productId ||
      item?.product?.id ||
      null
    );
  };

  // =========================================================
  // FETCH PRODUCTS
  // =========================================================
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await axios.get(
          `${API_BASE}/Products?page=1&pageSize=100`
        );

        console.log(
          "Bestseller Products API Response:",
          response.data
        );

        const firstProduct =
          Array.isArray(response.data)
            ? response.data[0]
            : response.data?.products?.[0] ||
              response.data?.items?.[0];

        console.log(
          "FIRST BESTSELLER PRODUCT:",
          JSON.stringify(
            firstProduct,
            null,
            2
          )
        );

        // ARRAY
        if (Array.isArray(response.data)) {
          setProducts(response.data);
        }

        // { products: [] }
        else if (
          Array.isArray(
            response.data?.products
          )
        ) {
          setProducts(
            response.data.products
          );
        }

        // { items: [] }
        else if (
          Array.isArray(
            response.data?.items
          )
        ) {
          setProducts(
            response.data.items
          );
        }

        // EMPTY
        else {
          setProducts([]);
        }

      } catch (err) {
        console.error(
          "Error fetching bestseller products:",
          err
        );

        setProducts([]);
        setError(
          "Unable to load products."
        );

      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // =========================================================
  // PRODUCT IMAGE
  // =========================================================
  const getProductImage = (image) => {
    const fallback =
      "https://dummyimage.com/400x400/e5e5e5/000000&text=No+Image";

    if (!image) {
      return fallback;
    }

    // OBJECT
    if (typeof image === "object") {
      image =
        image.imageUrl ||
        image.url ||
        image.path ||
        image.src ||
        image.image ||
        "";
    }

    if (
      typeof image !== "string" ||
      !image
    ) {
      return fallback;
    }

    // HTTPS
    if (
      image.startsWith("https://")
    ) {
      return image;
    }

    // HTTP → HTTPS
    if (
      image.startsWith("http://")
    ) {
      return image.replace(
        /^http:\/\//i,
        "https://"
      );
    }

    // RELATIVE
    return `${FILE_BASE}${
      image.startsWith("/")
        ? ""
        : "/"
    }${image}`;
  };

  // =========================================================
  // GET HOVER IMAGE
  // =========================================================
  const getHoverImage = (item) => {

    if (
      Array.isArray(item?.images) &&
      item.images.length > 1
    ) {
      return (
        item.images[1]?.imageUrl ||
        item.images[1]
      );
    }

    if (item?.hoverImage) {
      return item.hoverImage;
    }

    return item?.thumbnail;
  };

  // =========================================================
  // VIEW PRODUCT
  // =========================================================
  const handleProductClick = (item) => {
    const productId =
      getProductId(item);

    if (!productId) {
      console.error(
        "Product ID missing:",
        item
      );

      return;
    }

    console.log(
      "Navigating to Product:",
      productId
    );

    navigate(
      `/product/${productId}`
    );
  };

  // =========================================================
  // UI
  // =========================================================
  return (
    <div className="bestseller-container">

      {/* HEADER */}
      <div className="bestseller-header">

        <h1>
          Bestseller
        </h1>

        <Link
          to="/shop"
          className="see-all"
        >
          See all
        </Link>

      </div>

      {/* SUBTITLE */}
      <p className="subtitlez">
        Our most celebrated drapes,
        chosen time and again.
      </p>

      {/* PRODUCT GRID */}
      <div className="bestseller-product-grid">

        {/* LOADING */}
        {loading && (
          <p>
            Loading products...
          </p>
        )}

        {/* ERROR */}
        {!loading &&
          error && (
            <p>
              {error}
            </p>
          )}

        {/* NO PRODUCTS */}
        {!loading &&
          !error &&
          products.length === 0 && (
            <p>
              No products found.
            </p>
          )}

        {/* PRODUCTS */}
        {!loading &&
          !error &&
          products.length > 0 &&
          products.map((item) => {

            const productId =
              getProductId(item);

            const productName =
              getSafeValue(
                item?.product,
                "Product"
              );

            const finalPrice =
              getSafeValue(
                item?.finalPrice,
                ""
              );

            const thumbnail =
              item?.thumbnail;

            const hoverImage =
              getHoverImage(item);

            return (
              <div
                className="bestseller-card"
                key={
                  productId ||
                  Math.random()
                }
              >

                {/* IMAGE */}
                <div className="bestseller-image-box">

                  {/* MAIN IMAGE */}
                  <img
                    src={getProductImage(
                      thumbnail
                    )}
                    alt={productName}
                    className="main-img"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://dummyimage.com/400x400/e5e5e5/000000&text=No+Image";
                    }}
                  />

                  {/* HOVER IMAGE */}
                  <img
                    src={getProductImage(
                      hoverImage
                    )}
                    alt={productName}
                    className="hover-img"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://dummyimage.com/400x400/e5e5e5/000000&text=No+Image";
                    }}
                  />

                  {/* VIEW PRODUCT */}
                  <button
                    type="button"
                    className="buy-btn"
                    onClick={() =>
                      handleProductClick(
                        item
                      )
                    }
                  >
                    View Product
                  </button>

                </div>

                {/* PRODUCT NAME */}
                <h3>
                  {productName}
                </h3>

                {/* PRICE */}
                {finalPrice !== "" && (
                  <p>
                    Rs. {finalPrice}
                  </p>
                )}

              </div>
            );
          })}

      </div>

    </div>
  );
};

export default Bestseller;